import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Calculator, Lock, CheckCircle2, Loader2 } from 'lucide-react';
import { CashRegisterStatus } from '../hooks/useCashRegisterStatus';

interface CashRegisterStatusIndicatorProps {
  status: CashRegisterStatus;
  loading: boolean;
  error: string | null;
}

export const CashRegisterStatusIndicator: React.FC<CashRegisterStatusIndicatorProps> = ({
  status,
  loading,
  error
}) => {
  if (loading) {
    return (
      <Badge variant="secondary" className="flex items-center gap-1">
        <Loader2 className="w-3 h-3 animate-spin" />
        <span className="hidden sm:inline">Verificando caja...</span>
        <span className="sm:hidden">...</span>
      </Badge>
    );
  }

  if (error) {
    return (
      <Badge variant="destructive" className="flex items-center gap-1">
        <Lock className="w-3 h-3" />
        <span className="hidden sm:inline">Error estado caja</span>
        <span className="sm:hidden">Error</span>
      </Badge>
    );
  }

  if (status.isOpen) {
    const openedTime = status.openedAt ? new Date(status.openedAt).toLocaleTimeString('es-PE', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    }) : '';

    return (
      <Badge className="flex items-center gap-1 bg-green-100 text-green-800 hover:bg-green-100">
        <CheckCircle2 className="w-3 h-3" />
        <span className="hidden lg:inline">
          Caja Abierta {openedTime && `(${openedTime})`}
        </span>
        <span className="hidden sm:inline lg:hidden">Caja Abierta</span>
        <span className="sm:hidden">✓</span>
      </Badge>
    );
  }

  return (
    <Badge variant="destructive" className="flex items-center gap-1 bg-red-100 text-red-800 hover:bg-red-100">
      <Lock className="w-3 h-3" />
      <span className="hidden sm:inline">Caja Cerrada</span>
      <span className="sm:hidden">🔒</span>
    </Badge>
  );
};